import Router              from "vue-router";
import DocView             from "@/views/DocView";
import Error               from "@/views/Error";
import WebList             from "@/views/WebList";
import MonetaIframe        from "@/views/MonetaIframe";
import VerificationFailure from "@/views/VerificationFailure";
import VerificationSuccess from "@/views/VerificationSuccess";
import Card                from "@/views/Card";
import SmsStatus           from "@/views/SmsStatus";
import CheckPinCode        from "@/views/CheckPinCode";
import { http }            from "@/http";
import { store }           from "@/store";
import CreditCardForm      from "@/views/CreditCardForm";
import ClientDocList       from "@/views/ClientDocList";
import Repay               from "@/views/Repay";
import User                from "@/utils/User";

const uuid = "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

export const router = new Router({
    mode: "history",
    routes: [
        {
            path: `/:docsetID(${ uuid })/:msg(\\d+)/`,
            redirect: { name: "webList" }
        },
        {
            path: `/:docsetID(${ uuid })/`,
            component: WebList,
            name: "webList",
            props: true,
            beforeEnter: (to, from, next) => {
                if (store.getters.user.hasCredentials) {
                    next();
                    return;
                }
                http.get(`/ask-pin-code/${ to.params.docsetID }/`)
                    .then(r => {
                        if (r.data.ask_pin === 1) {
                            next({ name: "checkPinCode", params: to.params });
                        } else if (r.data.ask_pin === 0) {
                            store.commit("set_user", new User(
                                r.data.token,
                                "blank_pin_code",
                                to.params.docsetID
                            ));
                            next();
                        }
                    })
                    .catch(err => {
                        next({
                            name: "errorView",
                            params: { status: err.response.status, message: err.response.data.message }
                        });
                    });
            }
        },
        {
            path: `/:docsetID(${ uuid })/check-pin-code/`,
            component: CheckPinCode,
            name: "checkPinCode",
            props: true,
        },
        {
            path: "/doc/:url/",
            component: DocView,
            name: "docView",
            props: true,
        },
        {
            path: `/:docsetID(${ uuid })/client-doc-list/`,
            component: ClientDocList,
            name: "clientDocList",
            props: true,
            beforeEnter: (to, from, next) => {
                store.getters.user.docsetID = to.params.docsetID;
                if (store.getters.user.hasCredentials) {
                    next();
                    return;
                }
                next({ name: "checkPinCode", params: to.params });
            }
        },
        {
            path: "/sms-status/",
            component: SmsStatus,
            name: "smsStatus",
        },
        {
            path: `/:docsetID(${ uuid })/credit-card-form/`,
            component: CreditCardForm,
            name: "creditCardForm",
            props: true,
            beforeEnter: (to, from, next) => {
                store.getters.user.docsetID = to.params.docsetID;
                if (store.getters.user.hasCredentials) {
                    next();
                    return;
                }
                next({ name: "checkPinCode", params: to.params });
            }
        },
        {
            path: "/card/",
            component: Card,
            name: "card"
        },
        {
            path: `/:docsetID(${ uuid })/card-verification/`,
            component: MonetaIframe,
            name: "monetaIframe",
            props: true
        },
        {
            path: "/card-verification/failure/",
            component: VerificationFailure,
            name: "verificationFailure",
        },
        {
            path: "/card-verification/success/",
            component: VerificationSuccess,
            name: "verificationSuccess",
        },
        {
            path: "/asp/",
            component: DocView,
            name: "aspDocView",
            props: { url: "/api/asp/doc-detail/" },
        },
        {
            path: "/error/",
            component: Error,
            name: "errorView",
            props: route => route.params,
        },
        {
            path: "/repay/",
            component: Repay,
            name: "repayView"
        },
        {
            path: "*",
            component: Error,
            name: "404"
        }
    ]
});